// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import enUS from './en-US';
import ar from './ar';
import caES from './ca-ES';
import csCZ from './cs-CZ';
import daDK from './da-DK';
import deDE from './de-DE';
import elGR from './el-GR';
import esES from './es-ES';
import fiFI from './fi-FI';
import frFR from './fr-FR';
import heIL from './he-IL';
import huHU from './hu-HU';
import idID from './id-ID';
import itIT from './it-IT';
import jaJP from './ja-JP';
import koKR from './ko-KR';
import msMY from './ms-MY';
import nbNO from './nb-NO';
import nlNL from './nl-NL';
import plPL from './pl-PL';
import ptBR from './pt-BR';
import ptPT from './pt-PT';
import roRO from './ro-RO';
import ruRU from './ru-RU';
import svSE from './sv-SE';
import thTH from './th-TH';
import tlPH from './tl-PH';
import trTR from './tr-TR';
import ukUA from './uk-UA';
import viVN from './vi-VN';
import zhCN from './zh-CN';
import zhTW from './zh-TW';
const locales = {
  'en-US': {
    language: 'en',
    messages: enUS
  },
  ar: {
    language: 'ar',
    messages: ar
  },
  'ca-ES': {
    language: 'ca',
    messages: caES
  },
  'cs-CZ': {
    language: 'cs',
    messages: csCZ
  },
  'da-DK': {
    language: 'da',
    messages: daDK
  },
  'de-DE': {
    language: 'de',
    messages: deDE
  },
  'el-GR': {
    language: 'el',
    messages: elGR
  },
  'es-ES': {
    language: 'es',
    messages: esES
  },
  'fi-FI': {
    language: 'fi',
    messages: fiFI
  },
  'fr-FR': {
    language: 'fr',
    messages: frFR
  },
  'he-IL': {
    language: 'he',
    messages: heIL
  },
  'hu-HU': {
    language: 'hu',
    messages: huHU
  },
  'id-ID': {
    language: 'id',
    messages: idID
  },
  'it-IT': {
    language: 'it',
    messages: itIT
  },
  'ja-JP': {
    language: 'ja',
    messages: jaJP
  },
  'ko-KR': {
    language: 'ko',
    messages: koKR
  },
  'ms-MY': {
    language: 'ms',
    messages: msMY
  },
  'nb-NO': {
    language: 'nb',
    messages: nbNO
  },
  'nl-NL': {
    language: 'nl',
    messages: nlNL
  },
  'pl-PL': {
    language: 'pl',
    messages: plPL
  },
  'pt-BR': {
    language: 'pt',
    messages: ptBR
  },
  'pt-PT': {
    language: 'pt',
    messages: ptPT
  },
  'ro-RO': {
    language: 'ro',
    messages: roRO
  },
  'ru-RU': {
    language: 'ru',
    messages: ruRU
  },
  'sv-SE': {
    language: 'sv',
    messages: svSE
  },
  'th-TH': {
    language: 'th',
    messages: thTH
  },
  'tl-PH': {
    language: 'tl',
    messages: tlPH
  },
  'tr-TR': {
    language: 'tr',
    messages: trTR
  },
  'uk-UA': {
    language: 'uk',
    messages: ukUA
  },
  'vi-VN': {
    language: 'vi',
    messages: viVN
  },
  'zh-CN': {
    language: 'zh',
    messages: zhCN
  },
  'zh-TW': {
    language: 'zh',
    messages: zhTW
  }
};
export default locales;